import React, { useState } from "react";
import { Outlet } from "react-router-dom";
import { Modal } from "react-bootstrap";
import { useAuth } from "../../../context/AuthProvider";
import LoginForm from "../../Forms/LoginForm/LoginForm";
import { useNavigate } from "react-router-dom";

// interface LoginModalProps {
//   setShowLoginModal: (show: boolean) => void;
//   showLoginModal: boolean;
// }

const LoginModal: React.FC = () => {
  const [showModal, setShowModal] = useState<boolean>(false);
  const { user, loading } = useAuth();
  const navigate = useNavigate();

  React.useEffect(() => {
    if (!user && !loading) {
      setShowModal(true);
    } else {
      setShowModal(false);
    }
  }, [user, loading]);

  if (loading) {
    return <div>Loading...</div>; // Show a loading state while verifying the token
  }

  const handleModalClose = () => {
    setShowModal(false);
    navigate("/");
  };

  if (!user) {
    return (
      <Modal
        show={showModal}
        onHide={handleModalClose}
        centered
        className="d-flex"
      >
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body>
          <LoginForm />
        </Modal.Body>
      </Modal>
    );
  }

  return <Outlet />;
};

export default LoginModal;
